import { t } from 'ember-intl';
import AppPagePlanDetails from './plan-details';
import { VStack } from 'tio-ui/components/layout';
import Card from 'tio-ui/components/card';
import Heading from 'tio-ui/components/heading';
import Text from 'tio-ui/components/text';
import type { TOC } from '@ember/component/template-only';

type Detail = {
  title: string;
  description: string;
};

type MoreSection = {
  title: string;
  description: string;
};

interface AppPageRepaymentPlanDetailSignature {
  Args: {
    /** Translation key for the plan intro title */
    titleKey: string;
    /** Translation key for the plan intro description */
    descriptionKey: string;
    /** Plan detail rows (translation keys) */
    details: Detail[];
    /** Pros (translation keys) */
    pros: string[];
    /** Cons (translation keys) */
    cons: string[];
    /** Additional "keep in mind" sections (translation keys) */
    moreSections?: MoreSection[];
  };
}

// Shared layout for the standard / graduated / extended repayment plan pages:
// an intro card, the plan details card, and a fixed "Next Steps" card.

const AppPageRepaymentPlanDetail: TOC<AppPageRepaymentPlanDetailSignature> = <template>
  <VStack class="gap-6">
    <Card @padding="lg">
      <Heading @level={{2}} @size="lg" class="mb-2">
        {{t @titleKey}}
      </Heading>
      <Text @tag="p" @variant="muted">
        {{t @descriptionKey}}
      </Text>
    </Card>

    <AppPagePlanDetails
      @details={{@details}}
      @pros={{@pros}}
      @cons={{@cons}}
      @moreSections={{@moreSections}}
    />

    <Card @padding="lg">
      <Heading @level={{2}} @size="lg" class="mb-4">
        {{t "questions_you_have.repayment_plans.next_steps"}}
      </Heading>
      <div>
        <Text @weight="semibold" class="tio-fg-secondary block mb-1">
          {{t "questions_you_have.repayment_plans.make_the_switch.title"}}
        </Text>
        <Text @tag="p" @variant="muted" class="mb-4">
          {{t "questions_you_have.repayment_plans.make_the_switch.description" htmlSafe=true}}
        </Text>
        <Text @weight="semibold" class="tio-fg-secondary block mb-1">
          {{t "questions_you_have.repayment_plans.need_more_help.title"}}
        </Text>
        <Text @tag="p" @variant="muted">
          {{t "questions_you_have.repayment_plans.need_more_help.description" htmlSafe=true}}
        </Text>
      </div>
    </Card>
  </VStack>
</template>;

export default AppPageRepaymentPlanDetail;
